import { AssigneeActions, IAssigneeIdMap, IAssigneesStoreState } from "@gtmhub/assignees";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { INgRedux } from "@gtmhub/state-management";
import { IModalService } from "angular-ui-bootstrap";
import { DemoSessionCtrl } from "../controllers/demo-session";
import { IPlanningSession } from "../models/models";
import { PlanningSessionService } from "./planningSessionService";

const bindStateToThis = (state: IAssigneesStoreState): Record<string, unknown> => {
  return {
    assigness: state.assignees.map,
  };
};

export class DeleteSessionConfirmationService {
  assigness: IAssigneeIdMap;

  public static $inject = ["$uibModal", "PlanningSessionService", "UIErrorHandlingService", "$ngRedux", "AssigneeActions"];

  constructor(
    private $uibModal: IModalService,
    private planningSessionService: PlanningSessionService,
    private uiErrorHandlingService: UIErrorHandlingService,
    $ngRedux: INgRedux,
    assigneActions: AssigneeActions
  ) {
    $ngRedux.connect(bindStateToThis)(this);
    $ngRedux.dispatch(assigneActions.getAssignees());
  }

  public confirmDeletePlanningSession = (planningSession: IPlanningSession, onConfirmDelete: () => void): void => {
    this.$uibModal.open({
      templateUrl: require("../views/confirm-delete.jade"),
      windowClass: "medium",
      controller: [
        "$scope",
        "$uibModalInstance",
        ($scope, $uibModalInstance) => {
          $scope.indicators = {
            loading: true,
          };

          planningSession.parentId = "";
          $scope.session = { data: planningSession, id: planningSession.id };

          this.planningSessionService.checkForConflictsInSession(planningSession, "delete").then(
            (conflicts) => {
              $scope.conflicts = conflicts;
              $scope.indicators.loading = false;
              $scope.assignees = this.assigness;
              if (conflicts.totalCount === 0) {
                $scope.showConfirmation = true;
              } else {
                $scope.showConflicts = true;
              }
            },
            (error) => this.uiErrorHandlingService.handleModal(error)
          );

          $scope.confirm = () => {
            onConfirmDelete();
            $uibModalInstance.close();
          };

          $scope.close = () => {
            $uibModalInstance.close();
          };
        },
      ],
    });
  };
  public confirmDeleteDemoSession = (): void => {
    this.$uibModal.open({
      templateUrl: require("../views/confirm-delete-demo.jade"),
      windowClass: "medium",
      controller: DemoSessionCtrl,
    });
  };
}
